<template>
  <div>
    <Head />

    <nav class="breadcrumb_box" aria-label="breadcrumb">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">{{ $t('首頁') }}</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ $t('學人宿舍借住申請書') }}</li>
      </ol>
    </nav>
    <div class="wrapper form form_2" v-if="ApplyData && ApplyData.Apply">
      <svg class="bg"></svg>
      <div class="container">
        <div class="box_bg">
          <div class="title_box">
            <h1>{{ $t('學人宿舍借住申請書') }}</h1>
            <button class="open_btn" @click="showPhoto()">{{ $t('流程圖') }} <span>＋</span></button>
          </div>
          <div class="process_box">
            <img src="img/img_9.png" alt="">
          </div>
          <div class="box">
            <div class="form-group">
              <label>{{ $t('申請單位') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T2_ApplyUnit" data-required="1"
                :data-required-msg="$t('請輸入申請單位')" aria-describedby="" :placeholder="$t('請輸入申請單位')">
            </div>
            <div class="form-group">
              <label>{{ $t('借住人類別') }}</label>
              <select class="form-control" v-model="ApplyData.Apply.T2_ResidentType" data-required="1"
                :data-required-msg="$t('請選擇借住人類別')" aria-describedby="" :placeholder="$t('請選擇借住人類別')">
                <option value="" selected disabled>{{ $t('請選擇') }}</option>
                <option value="1">{{ $t('學人') }}</option>
                <option value="2">{{ $t('新進教師') }}</option>
                <option value="3">{{ $t('專案申請人員') }}</option>
              </select>
            </div>
            <div class="form-group date_box">
              <label>{{ $t('借住期間') }}</label>
              <div class="form-group">
                <input type="date" class="form-control" v-model="ApplyData.Apply.T2_StayPeriodStart" data-required="1"
                  :data-required-msg="$t('請輸入借住期間(起)')" aria-describedby="" :placeholder="$t('請輸入借住期間(起)')" disabled>
                <label for="">{{ $t('至') }}</label>
                <input type="date" class="form-control" v-model="ApplyData.Apply.T2_StayPeriodEnd" data-required="1"
                  :data-required-msg="$t('請輸入借住期間(迄)')" aria-describedby="" :placeholder="$t('請輸入借住期間(迄)')" disabled>
              </div>
            </div>
          </div>
          <div class="title">
            <h2>{{ $t('申請人') }}</h2>
          </div>
          <div class="box">
            <div class="form-group">
              <label>{{ $t('申請人姓名') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T2_ApplyName" data-required="1"
                :data-required-msg="$t('請輸入申請人姓名')" aria-describedby="" :placeholder="$t('請輸入申請人姓名')">
            </div>
            <div class="form-group">
              <label>{{ $t('職稱') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T2_ApplyTitle" data-required="1"
                :data-required-msg="$t('請輸入職稱')" aria-describedby="" :placeholder="$t('請輸入職稱')">
            </div>
            <div class="form-group">
              <label>{{ $t('連絡電話（校內分機）') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T2_ApplyPhoneExt" data-required="1"
                :data-required-msg="$t('請輸入連絡電話（校內分機）')" aria-describedby="" :placeholder="$t('請輸入連絡電話（校內分機）')">
            </div>
            <div class="form-group">
              <label>{{ $t('手機') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T2_ApplyMobile" data-required="1"
                :data-required-msg="$t('請輸入手機')" aria-describedby="" :placeholder="$t('請輸入手機')">
            </div>
            <div class="form-group">
              <label>{{ $t('電子信箱') }}</label>
              <input type="email" class="form-control" v-model="ApplyData.Apply.T2_ApplyEmail" data-required="1"
                :data-required-msg="$t('請輸入電子信箱')" aria-describedby="" :placeholder="$t('請輸入電子信箱')">
            </div>
          </div>
          <div class="title">
            <h2>{{ $t('借住人') }}</h2>
          </div>
          <div class="box">
            <div class="form-group">
              <label>{{ $t('同申請人') }}</label>
              <div class="check">
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="T2_SameApply_N" v-bind:value="false"
                    v-model="ApplyData.Apply.T2_SameApply">
                  <label class="form-check-label" for="T2_SameApply_N">
                    {{ $t('否') }}
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="T2_SameApply_Y" v-bind:value="true"
                    v-model="ApplyData.Apply.T2_SameApply">
                  <label class="form-check-label" for="T2_SameApply_Y">
                    {{ $t('是') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>{{ $t('國籍') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T2_TenantNationality" data-required="1"
                :data-required-msg="$t('請輸入國籍')" aria-describedby="" :placeholder="$t('請輸入國籍')">
            </div>
            <div class="form-group" v-show="!ApplyData.Apply.T2_SameApply">
              <label>{{ $t('借住者姓名') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T2_TenantName"
                :data-required="!ApplyData.Apply.T2_SameApply ? '1' : '0'" :data-required-msg="$t('請輸入借住者姓名')"
                aria-describedby="" :placeholder="$t('請輸入借住者姓名')">
            </div>
            <!-- <div class="form-group id_box">
              <label>{{ $t('身分確認') }}</label>
              <div class="form-group">
                <input type="" class="form-control" v-model="ApplyData.Apply.T2_IdentityNumber" data-required="1"
                :data-required-msg="$t('請輸入身分證字號或護照號碼')" aria-describedby="" :placeholder="$t('請輸入身分證字號或護照號碼')">
                <button class="confirm_btn">確認</button>
              </div>
              <p>{{ $t('請輸入身分證字號或護照號碼進行身分驗證') }}</p>
            </div> -->
            <div class="form-group" v-show="!ApplyData.Apply.T2_SameApply">
              <label>{{ $t('性別') }}</label>
              <div class="check">
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="T2_TenantGender_M" v-bind:value="'男'"
                    v-model="ApplyData.Apply.T2_TenantGender">
                  <label class="form-check-label" for="T2_TenantGender_M">
                    {{ $t('男') }}
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="T2_TenantGender_F" v-bind:value="'女'"
                    v-model="ApplyData.Apply.T2_TenantGender">
                  <label class="form-check-label" for="T2_TenantGender_F">
                    {{ $t('女') }}
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group" v-show="!ApplyData.Apply.T2_SameApply">
              <label>{{ $t('借住人服務單位') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T2_TenantUnit"
                :data-required="!ApplyData.Apply.T2_SameApply ? '1' : '0'" :data-required-msg="$t('請輸入借住人服務單位')"
                aria-describedby="" :placeholder="$t('請輸入借住人服務單位')">
            </div>
            <div class="form-group" v-show="!ApplyData.Apply.T2_SameApply">
              <label>{{ $t('職稱') }}</label>
              <input type="text" class="form-control" v-model="ApplyData.Apply.T2_TenantTitle"
                :data-required="!ApplyData.Apply.T2_SameApply ? '1' : '0'" :data-required-msg="$t('請輸入職稱')"
                aria-describedby="" :placeholder="$t('請輸入職稱')">
            </div>
            <hr class="line">
            <p class="textarea_p">{{ $t('檢附國內外學人相關資料及核准公文等如附件') }}</p>
            <div class="form-group full textarea_box">
              <label>{{ $t('申請事由') }}</label>
              <div class="textarea">
                <textarea class="form-control" rows="4" v-model="ApplyData.Apply.T2_ApplyReason" data-required="1"
                  :data-required-msg="$t('請輸入申請事由')" aria-describedby="" :placeholder="$t('請輸入申請事由')"></textarea>
                <!-- <p>檢附過內外學人相關資料及核准公文等如附件</p> -->
              </div>
            </div>
            <div class="form-group" style="flex-wrap: wrap;">
              <label>{{ $t('附件上傳') }}<span style="color: red;"
                  v-if="ApplyData.Apply.AId != -1 && ApplyData.Apply.T2_AttachmentUpload">
                  {{ $t('(已上傳, 可更新)') }}</span></label>
              <div class="custom_file form-control">
                <input type="file" id="T2_AttachmentUpload"
                  accept=".zip,.rar,.7z,.bmp,.jpg,.gif,.tif,.png,.gif,.jpeg,.odt,.doc,.docx,.pdf,.txt"
                  @change="checkFiles">
                <input type="hidden" id="T2_AttachmentUpload_name" data-namgtag="1" />
                <input type="hidden" v-model="ApplyData.Apply.T2_AttachmentUpload" id="T2_AttachmentUpload_data" />
                <label class="" for="T2_AttachmentUpload">{{ $t('上傳檔案') }}</label>
              </div>              
              <small class="form-text text-muted" style="margin-top: 5px; color: #6c757d; font-size: 0.875rem;">
                <div>{{ $t('支援格式') }}</div>
                <div>{{ $t('檔案大小限制') }}</div>
              </small>
            </div>
          </div>
          <div class="title">
            <h2>{{ $t('隨行眷屬') }}</h2>
          </div>
          <div class="box">
            <ul class="list">
              <li class="title">
                <div class="form-group">
                  <label for="">{{ $t('稱謂') }}</label>
                </div>
                <div class="form-group">
                  <label for="">{{ $t('姓名') }}</label>
                </div>
                <div class="form-group">
                  <label for="">{{ $t('性別') }}</label>
                </div>
                <div class="form-group">
                  <label for="">{{ $t('年齡') }}</label>
                </div>
                <div class="form-group">
                  <label for="">{{ $t('備註') }}</label>
                </div>
                <button class="new_btn" @click="addAccompanyingFamily()">{{ $t('新增') }}</button>
              </li>
              <li class="main" v-for="(AccompanyingFamily, index) in AccompanyingFamilys" :key="index">
                <div class="form-group">
                  <label>{{ $t('稱謂') }}</label>
                  <input type="text" class="form-control" v-model="AccompanyingFamily.Title" data-required="1"
                    :data-required-msg="$t('請輸入稱謂')" aria-describedby="" :placeholder="$t('請輸入稱謂')">
                </div>
                <div class="form-group">
                  <label>{{ $t('姓名') }}</label>
                  <input type="text" class="form-control" v-model="AccompanyingFamily.Name" data-required="1"
                    :data-required-msg="$t('請輸入姓名')" aria-describedby="" :placeholder="$t('請輸入姓名')">
                </div>
                <div class="form-group">
                  <label>{{ $t('性別') }}</label>
                  <select class="form-control" v-model="AccompanyingFamily.Gender" data-required="1"
                    :data-required-msg="$t('請選擇性別')" aria-describedby="" :placeholder="$t('請選擇性別')">
                    <option value="" selected disabled>{{ $t('請選擇') }}</option>
                    <option value="男">{{ $t('男') }}</option>
                    <option value="女">{{ $t('女') }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>{{ $t('年齡') }}</label>
                  <input type="number" class="form-control" v-model="AccompanyingFamily.Age" data-required="1"
                    :data-required-msg="$t('請輸入年齡')" aria-describedby="" :placeholder="$t('請輸入年齡')">
                </div>
                <div class="form-group">
                  <label>{{ $t('備註') }}</label>
                  <input type="text" class="form-control" v-model="AccompanyingFamily.Remarks" data-required="0"
                    :data-required-msg="$t('請輸入備註')" aria-describedby="" :placeholder="$t('請輸入備註')">
                </div>
                <button class="cancel_btn" @click="removeAccompanyingFamily(index)">{{ $t('刪除') }}</button>
              </li>
            </ul>
          </div>
          <div class="title">
            <h2>{{ $t('注意事項') }}</h2>
          </div>
          <div class="box">
            <p class="text">
              {{ $t('本校學人宿舍係以國內外來校講學研究之講座、客座、交換之教授、副教授、助理教授、或講師及同等級之研究學人，或其他情況特殊經專案簽報校長核准人員為申請對象，借住期限以聘期為限。') }}
              <br>
              {{ $t('來台參觀訪問者，請向事務組（分機62102）申請I-HOUSE（國際學人會館）。') }}
            </p>
          </div>
          <template
            v-if="(local == 'zh_tw' && ApplyData.apply_2_need_tw) || (local == 'en' && ApplyData.apply_2_need_en)">
            <div class="title">
              <h2>{{ $t('閱讀須知') }}</h2>
            </div>
            <div class="box">
              <div class="instructions-content" @scroll="handleScroll" ref="instructionsContent">
                <div v-html="local == 'zh_tw' ? ApplyData.apply_2_need_tw : ApplyData.apply_2_need_en">
                </div>
              </div>
              <div class="instructions-checkbox-container">
                <div class="form-check instructions_check" style="font-size: 1.1rem;">
                  <input class="form-check-input" type="checkbox" v-model="instructions_check" id="flexCheckDefault"
                    :disabled="!scrolledToBottom">
                  <label class="form-check-label" for="flexCheckDefault">
                    我已閱讀條款
                  </label>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="btn_box">
          <button class="send_box" @click="send()">{{ $t('送出') }}</button>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    "首頁": "首頁",
    "學人宿舍借住申請書": "學人宿舍借住申請書",
    "流程圖": "流程圖",
    "申請單位": "申請單位",
    "請輸入申請單位": "請輸入申請單位",
    "借住期間": "借住期間",
    "請輸入借住期間(起)": "請輸入借住期間(起)",
    "至": "至",
    "請輸入借住期間(迄)": "請輸入借住期間(迄)",
    "申請人": "申請人",
    "申請人姓名": "申請人姓名",
    "請輸入申請人姓名": "請輸入申請人姓名",
    "職稱": "職稱",
    "請輸入職稱": "請輸入職稱",
    "連絡電話（校內分機）": "連絡電話（校內分機）",
    "請輸入連絡電話（校內分機）": "請輸入連絡電話（校內分機）",
    "手機": "手機",
    "請輸入手機": "請輸入手機",
    "借住人": "借住人",
    "借住者姓名": "借住者姓名",
    "請輸入借住者姓名": "請輸入借住者姓名",
    "國籍": "國籍",
    "請輸入國籍": "請輸入國籍",
    "身分確認": "身分確認",
    "請輸入身分證字號或護照號碼": "請輸入身分證字號或護照號碼",
    "請輸入身分證字號或護照號碼進行身分驗證": "請輸入身分證字號或護照號碼進行身分驗證",
    "性別": "性別",
    "男": "男",
    "女": "女",
    "借住人服務單位": "借住人服務單位",
    "請輸入借住人服務單位": "請輸入借住人服務單位",
    "檢附過內外學人相關資料及核准公文等如附件": "檢附過內外學人相關資料及核准公文等如附件",
    "申請事由": "申請事由",
    "請輸入申請事由": "請輸入申請事由",
    "附件上傳": "附件上傳",
    "(已上傳, 可更新)": "(已上傳, 可更新)",
    "上傳檔案": "上傳檔案",
    "隨行眷屬": "隨行眷屬",
    "稱謂": "稱謂",
    "姓名": "姓名",
    "年齡": "年齡",
    "備註": "備註",
    "新增": "新增",
    "請輸入稱謂": "請輸入稱謂",
    "請輸入姓名": "請輸入姓名",
    "請選擇性別": "請選擇性別",
    "請選擇": "請選擇",
    "請輸入年齡": "請輸入年齡",
    "請輸入備註": "請輸入備註",
    "刪除": "刪除",
    "注意事項": "注意事項",
    "本校學人宿舍係以國內外來校講學研究之講座、客座、交換之教授、副教授、助理教授、或講師及同等級之研究學人，或其他情況特殊經專案簽報校長核准人員為申請對象，借住期限以聘期為限。": "本校學人宿舍係以國內外來校講學研究之講座、客座、交換之教授、副教授、助理教授、或講師及同等級之研究學人，或其他情況特殊經專案簽報校長核准人員為申請對象，借住期限以聘期為限。",
    "來台參觀訪問者，請向事務組（分機62102）申請I-HOUSE（國際學人會館）。": "來台參觀訪問者，請向事務組（分機62102）申請I-HOUSE（國際學人會館）。",
    "送出": "送出",
    "請先登入帳號": "請先登入帳號",
    "請稍候...": "請稍候...",
    "錯誤": "錯誤",
    "確定": "確定",
    "Email格式錯誤": "Email格式錯誤",
    "數字不可小於0": "數字不可小於0",
    "請選擇申請宿舍種類": "請選擇申請宿舍種類",
    "請選擇借住人性別": "請選擇借住人性別",
    "儲存成功": "儲存成功",
    "檔案大小超過100MB": "檔案大小超過100MB",
    "處理檔案過程發生錯誤:": "處理檔案過程發生錯誤:",
    "若持續發生此問題請聯繫客服人員, 造成不便敬請見諒": "若持續發生此問題請聯繫客服人員, 造成不便敬請見諒",
    "支援格式": "支援格式：ZIP、RAR、7Z、BMP、JPG、GIF、TIF、PNG、JPEG、ODT、DOC、DOCX、PDF、TXT",
    "檔案大小限制": "檔案大小限制：100MB",
  },
  en: {
    "首頁": "Home Page",
    "學人宿舍借住申請書": "Application form for Visiting Scholars Dormitory Rental",
    "流程圖": "Process Flowchart",
    "申請單位": "Applying Depatment",
    "請輸入申請單位": "Please enter applying department",
    "借住期間": "Duration of Stay",
    "請輸入借住期間(起)": "Please enter the start date of staying",
    "至": "to",
    "請輸入借住期間(迄)": "Please enter the end date of staying",
    "申請人": "Applicant",
    "申請人姓名": "Applicant's Full Name",
    "請輸入申請人姓名": "Please enter applicant's full name",
    "職稱": "Position Title",
    "請輸入職稱": "Please enter your position title",
    "連絡電話（校內分機）": "Telephone Number (Campus Extention)",
    "請輸入連絡電話（校內分機）": "Please enter your telephone number (campus extention)",
    "手機": "Mobile Number",
    "請輸入手機": "Please enter your mobile number",
    "借住人": "Occupant",
    "借住者姓名": "Occupant's Full Name",
    "請輸入借住者姓名": "Please enter the occupant's full name",
    "國籍": "Nationality",
    "請輸入國籍": "Please enter the occupant's nationality",
    "身分確認": "Identity Verification",
    "請輸入身分證字號或護照號碼": "Please enter national ID number or passport number",
    "請輸入身分證字號或護照號碼進行身分驗證": "Please enter naitonal ID number or passport number for identity verificaiton",
    "性別": "Gender",
    "男": "Male",
    "女": "Female",
    "借住人服務單位": "Occupant's Department",
    "請輸入借住人服務單位": "Please enter the occupant's department",
    "檢附過內外學人相關資料及核准公文等如附件": "Attached are relevant documents and approval letters for domestic and international visiting scholars.",
    "申請事由": "Reason for application",
    "請輸入申請事由": "Please enter the reason for application",
    "附件上傳": "Attachment Upload ",
    "(已上傳, 可更新)": "Uploaded, updates allowed",
    "上傳檔案": "File Upload",
    "隨行眷屬": "Accompanying Family Members",
    "稱謂": "Relationship",
    "姓名": "Full Name",
    "年齡": "Age",
    "備註": "Additional Information",
    "新增": "Add",
    "請輸入稱謂": "Please enter the relationship",
    "請輸入姓名": "Please enter your full name",
    "請選擇性別": "Please select the gender",
    "請選擇": "Please select",
    "請輸入年齡": "Please enter age",
    "請輸入備註": "Please enter additional information",
    "刪除": "Delete",
    "注意事項": "Important Notes",
    "本校學人宿舍係以國內外來校講學研究之講座、客座、交換之教授、副教授、助理教授、或講師及同等級之研究學人，或其他情況特殊經專案簽報校長核准人員為申請對象，借住期限以聘期為限。": "NCCU's scholar dormitories are designated for visiting scholars, including domestic and international visiting professors, guest professors, exchange professors, associate professors, assistant professors, or lecturers, as well as researchers of equivalent rank or other personnel under special circumstances approved by the President through a specific report. The duration of residence is limited to the term of appointment.",
    "來台參觀訪問者，請向事務組（分機62102）申請I-HOUSE（國際學人會館）。": "For visitors to Taiwan, please apply for NCCU-iHouse at the General Management Section (Ext. 62102).",
    "送出": "Submit",
    "請先登入帳號": "Please log in first",
    "請稍候...": "Please wait while we process",
    "錯誤": "Error",
    "確定": "Confirm",
    "Email格式錯誤": "Invalid Email Format",
    "數字不可小於0": "Number cannot be less than 0",
    "請選擇申請宿舍種類": "Please select the dormitory type",
    "請選擇借住人性別": "Please select the occupant's gender",
    "儲存成功": "Sucessfully saved",
    "檔案大小超過100MB": "The size of file is over 100 MB",
    "處理檔案過程發生錯誤:": "An error occurs while processing the file:",
    "若持續發生此問題請聯繫客服人員, 造成不便敬請見諒": "If this problem persists, please contact system support staff. We apologize for any inconvenience caused by the system error.",
    "支援格式": "Supported formats: ZIP, RAR, 7Z, BMP, JPG, GIF, TIF, PNG, JPEG, ODT, DOC, DOCX, PDF, TXT",
    "檔案大小限制": "File size limit: 100MB",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "Apply_2",
  i18n,
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      ApplyData: {},
      AccompanyingFamilys: [],
      local: "zh_tw",
      instructions_check: false,
      scrolledToBottom: false,
    };
  },
  watch: {
    'ApplyData.Apply.T2_SameApply': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.ApplyData.Apply.T2_TenantName = this.ApplyData.T2_TenantName;
          this.ApplyData.Apply.T2_TenantGender = this.ApplyData.T2_TenantGender;
          this.ApplyData.Apply.T2_TenantUnit = this.ApplyData.T2_TenantUnit;
          this.ApplyData.Apply.T2_TenantTitle = this.ApplyData.T2_TenantTitle;
        } else {
          this.ApplyData.Apply.T2_TenantName = "";
          this.ApplyData.Apply.T2_TenantUnit = "";
          this.ApplyData.Apply.T2_TenantTitle = "";
        }
      }
    },
  },
  beforeCreate: function () {
    if (!$cookies.isKey("dormitory_login_token")) {
      Swal.fire({
        title: this.$t("請先登入帳號"),
        icon: "info",
        allowOutsideClick: false,
        heightAuto: false,
        willClose: () => {
          this.$router.push({
            name: "Home",
          });
        },
      });
      return;
    }
  },
  created: function () {
    //this.StartTime = this.$route.params.StartTime;
    //this.EndTime = this.$route.params.EndTime;
    //this.SCRId = this.$route.params.SCRId;
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/Apply",
        {
          params: { AId: this.$route.params.AId, Type: 2, token: $cookies.get("dormitory_login_token") },
        }
      )
      .then((response) => {
        this.ApplyData = response.data;
        if (!this.ApplyData.Apply) {
          if (this.ApplyData.Error) {
            Swal.fire({
              title: this.ApplyData.Error,
              icon: "info",
              allowOutsideClick: false,
              heightAuto: false,
              willClose: () => {
                this.$router.push({
                  name: this.ApplyData.RouterName,
                });
              },
            });
          } else {
            this.$router.push({
              name: "Home",
            });
          }
        }
        this.ApplyData.Apply.T2_StayPeriodStart = this.$route.params.StartTime;
        this.ApplyData.Apply.T2_StayPeriodEnd = this.$route.params.EndTime;
        this.ApplyData.Apply.T2_SCRId = this.$route.params.SCRId;
        this.AccompanyingFamilys = this.ApplyData.AccompanyingFamilys;
        // if (this.ApplyData.Apply.T2_ApplyDate && this.ApplyData.Apply.T2_ApplyDate != "0001-01-01T00:00:00") {
        //   this.ApplyData.Apply.T2_ApplyDate = this.convertDatetimeString(this.ApplyData.Apply.T2_ApplyDate, "YYYY-MM-DD")
        // } else {
        //   this.ApplyData.Apply.T2_ApplyDate = "";
        // }
        if (this.ApplyData.Apply.T2_StayPeriodStart && this.ApplyData.Apply.T2_StayPeriodStart != "0001-01-01T00:00:00") {
          this.ApplyData.Apply.T2_StayPeriodStart = this.convertDatetimeString(this.ApplyData.Apply.T2_StayPeriodStart, "YYYY-MM-DD")
        } else {
          this.ApplyData.Apply.T2_StayPeriodStart = "";
        }
        if (this.ApplyData.Apply.T2_StayPeriodEnd && this.ApplyData.Apply.T2_StayPeriodEnd != "0001-01-01T00:00:00") {
          this.ApplyData.Apply.T2_StayPeriodEnd = this.convertDatetimeString(this.ApplyData.Apply.T2_StayPeriodEnd, "YYYY-MM-DD")
        } else {
          this.ApplyData.Apply.T2_StayPeriodEnd = "";
        }
        if (this.ApplyData.Applt.T2_ResidentType == 0) {
          this.ApplyData.Applt.T2_ResidentType = "";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("dormitory_site_lang")) {
      i18n.locale = $cookies.get("dormitory_site_lang");
      this.local = $cookies.get("dormitory_site_lang");
    } else {
      i18n.locale = "zh_tw";
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    send() {
      if (((this.local == 'zh_tw' && this.ApplyData.apply_2_need_tw) || (this.local == 'en' && this.ApplyData.apply_2_need_en))) {
        if (!this.scrolledToBottom) {
          Swal.fire({
            title: this.$t("錯誤"),
            text: this.$t("請將需知內容滾動至底部後，再勾選「我已閱讀條款」"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
            heightAuto: false,
          });
          hasError = true;
          return false;
        }
        if (!this.instructions_check) {
          Swal.fire({
            title: this.$t("錯誤"),
            text: this.$t("請詳細閱讀需知並勾選「我已閱讀條款」"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: this.$t("確定"),
            heightAuto: false,
          });
          hasError = true;
          return false;
        }
      }
      Swal.fire({
        title: this.$t("請稍候..."),
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      var hasError = false;
      let that = this;
      $(".form_2").find("[data-required='1']").each(function () {
        var input = $(this);
        if (!input.val() || input.val() == '-1') {
          Swal.fire({
            title: that.$t("錯誤"),
            text: input.data("required-msg"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
            willClose: () => {
              //input.focus();
            },
          });
          hasError = true;
          return false;
        } else if (input.attr("type") == "email" &&
          !Validate.reg_email(input.val())) {
          Swal.fire({
            title: that.$t("錯誤"),
            text: that.$t("Email格式錯誤"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
          });
          hasError = true;
          return false;
        } else if (input.attr("type") == "number" &&
          input.val() < 0) {
          Swal.fire({
            title: that.$t("錯誤"),
            text: that.$t("數字不可小於0"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
          });
          hasError = true;
          return false;
        }
      });
      if (that.ApplyData.Apply.T2_SCRId == -1) {
        Swal.fire({
          title: that.$t("錯誤"),
          text: that.$t("請選擇申請宿舍種類"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
          heightAuto: false,
        });
        hasError = true;
        return false;
      }
      if (!that.ApplyData.Apply.T2_SameApply &&
        !that.ApplyData.Apply.T2_TenantGender) {
        Swal.fire({
          title: that.$t("錯誤"),
          text: that.$t("請選擇借住人性別"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
          heightAuto: false,
        });
        hasError = true;
        return false;
      }
      if (hasError) {
        return;
      }
      // 儲存檔案名稱
      var AttachmentNames = "{";
      $("[data-namgtag='1']").each(function () {
        if (AttachmentNames.length > 1) { AttachmentNames += ", "; }
        var input = $(this);
        AttachmentNames += '"' + input.attr("id").replace("_name", "") + '": "' + input.val() + '"';
      });
      AttachmentNames += "}";
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/Apply",
        type: "post",
        data: {
          ApplyJson: JSON.stringify(that.ApplyData.Apply),
          AttachmentNames: AttachmentNames,
          AccompanyingFamilys: JSON.stringify(that.AccompanyingFamilys),
          lang: that.local,
          token: $cookies.get("dormitory_login_token")
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.ok) {
            Swal.fire({
              title: that.$t("填寫完成"),
              icon: "success",
              allowOutsideClick: false,
              confirmButtonText: that.$t("返回首頁"),
              showCancelButton: res.gotoUrl ? true : false,
              cancelButtonText: that.$t("前往簽核流程"),
              heightAuto: false,
              // willClose: () => {                
              //   if (res.gotoUrl) {
              //     location.href = res.gotoUrl;
              //   } else {
              //     that.$router.push({
              //       name: "Home"
              //     });
              //   }
              // },
            }).then((result) => {
              if (result.isConfirmed) {
                that.$router.push({
                  name: "Home"
                });
              } else if (result.isDismissed) {
                location.href = res.gotoUrl;
              }
            });
          } else if (res.error) {
            Swal.fire({
              title: that.$t("錯誤"),
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
              heightAuto: false,
            });
          }
        }
      });
    },
    showPhoto() {
      $('.form .box_bg .process_box').slideToggle("slow");
      $(".form .box_bg .title_box .open_btn").toggleClass("add");
    },
    addAccompanyingFamily() {
      this.AccompanyingFamilys.push({
        Title: '',
        Name: '',
        Gender: '',
        Age: '',
        Remarks: '',
      });
    },
    removeAccompanyingFamily(index) {
      this.AccompanyingFamilys.splice(index, 1);
    },
    checkFiles(event) {
      let that = this;
      var id = event.target.id;
      var e = event.target;
      if (e.files.length != 0) {
        // 顯示請稍候
        Swal.fire({
          title: that.$t("請稍候..."),
          allowOutsideClick: false,
          showConfirmButton: false,
          heightAuto: false,
          willOpen: function () {
            Swal.showLoading();
          },
        });
        var file = e.files[0];
        // 不進行壓縮的情況要檢查大小
        if (file.size > 104857600) {
          Swal.fire({
            title: that.$t("錯誤"),
            text: that.$t("檔案大小超過100MB"),
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: that.$t("確定"),
            heightAuto: false,
          });
        } else {
          var reader = new FileReader();
          reader.onloadend = function () {
            if (id == "T2_AttachmentUpload") {
              that.ApplyData.Apply.T2_AttachmentUpload = reader.result;
            }
            $("#" + id + "_data").val(reader.result);
            $("#" + id + "_name").val(file.name);
            //$("#" + id).val('');
            Swal.close();
          };
          reader.onerror = function (error) {
            $("#" + id).val("");
            Swal.fire({
              title: that.$t("錯誤"),
              html:
                that.$t("處理檔案過程發生錯誤:") + "<br />" +
                error +
                "<br />" + that.$t("若持續發生此問題請聯繫客服人員, 造成不便敬請見諒"),
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
              heightAuto: false,
            });
          };
          reader.readAsDataURL(file);
        }
      }
    },
    convertDatetimeString(time, format) {
      var date = new Date(
        time.replace(
          /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
          "$4:$5:$6 $2/$3/$1"
        )
      );
      return moment(date).format(format);
    },
    numberToCurrencyNo(value) {
      if (!value) return 0
      const intPart = Math.trunc(value)
      const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      let floatPart = ''
      const valueArray = value.toString().split('.')
      if (valueArray.length === 2) {
        floatPart = valueArray[1].toString()
        return intPartFormat + '.' + floatPart
      }
      return intPartFormat + floatPart
    },
    handleScroll(event) {
      const element = event.target;
      const scrollTop = element.scrollTop;
      const scrollHeight = element.scrollHeight;
      const clientHeight = element.clientHeight;

      // 檢查是否滾動到底部（允許2px的容差）
      if (scrollTop + clientHeight >= scrollHeight - 2) {
        this.scrolledToBottom = true;
      }
    }
  },
};
</script>

<style scoped>
.instructions-content {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ddd;
  padding: 15px;
  margin-bottom: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.instructions-content::-webkit-scrollbar {
  width: 8px;
}

.instructions-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.instructions-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.instructions-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.instructions-checkbox-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  width: 100%;
}

.instructions_check {
  display: inline-flex;
  gap: 8px;
}

.instructions_check input[type="checkbox"]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.instructions_check input[type="checkbox"]:disabled+label {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
